// import Link from 'next/link'; // 未使用のためコメントアウト
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-200 text-gray-700 p-4 mt-auto">
      <div className="container mx-auto text-center">
        <p>
          &copy; {new Date().getFullYear()}{' '}
          <a
            href="https://tech.tokiraku.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            ときらく
          </a>
          . All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
